import {
  PRIVACY_CORE_CUSTOM_EVENT_NAMES,
  INLINE_COOKIE_CUSTOM_EVENT_NAMES,
  getPrivacyCoreEventName,
  getInlineEventName,
} from '@nike/privacy-shared-logic';
import type { ContextFrameNamesModal } from '@nike/privacy-types';

/**
 * @name getPrivacyCoreCustomEventName
 * @description Returns an object containing privacy core custom event names.
 * @param {undefined | ContextFrameNamesModal} uniqueEventsPrefix - A unique extra prefix for custom events
 * @returns {object}
 */
export const getPrivacyCoreCustomEventNames = (
  uniqueEventsPrefix: ContextFrameNamesModal | undefined,
): {
  INITIALIZE_ERROR: string;
  CONTEXT_FRAMES_GET_ERROR: string;
  PERMISSIONS_UPDATING: string;
  PERMISSIONS_UPDATED: string;
  PERMISSIONS_GET_ERROR: string;
  PERMISSIONS_UPDATE_ERROR: string;
} => ({
  INITIALIZE_ERROR: getPrivacyCoreEventName(PRIVACY_CORE_CUSTOM_EVENT_NAMES.INITIALIZE_ERROR),
  CONTEXT_FRAMES_GET_ERROR: getPrivacyCoreEventName(
    PRIVACY_CORE_CUSTOM_EVENT_NAMES.CONTEXT_FRAMES_GET_ERROR,
    uniqueEventsPrefix,
  ),
  PERMISSIONS_UPDATING: getPrivacyCoreEventName(
    PRIVACY_CORE_CUSTOM_EVENT_NAMES.PERMISSIONS_UPDATING,
    uniqueEventsPrefix,
  ),
  PERMISSIONS_UPDATED: getPrivacyCoreEventName(
    PRIVACY_CORE_CUSTOM_EVENT_NAMES.PERMISSIONS_UPDATED,
    uniqueEventsPrefix,
  ),
  PERMISSIONS_GET_ERROR: getPrivacyCoreEventName(
    PRIVACY_CORE_CUSTOM_EVENT_NAMES.PERMISSIONS_GET_ERROR,
    uniqueEventsPrefix,
  ),
  PERMISSIONS_UPDATE_ERROR: getPrivacyCoreEventName(
    PRIVACY_CORE_CUSTOM_EVENT_NAMES.PERMISSIONS_UPDATE_ERROR,
    uniqueEventsPrefix,
  ),
});

/**
 * @name getInlineCustomEventNames
 * @description Returns an object containing inline custom event names.
 * @param {undefined | ContextFrameNamesModal} uniqueEventsPrefix - A unique extra prefix for custom events
 * @returns {object}
 */
export const getInlineCustomEventNames = (
  uniqueEventsPrefix: ContextFrameNamesModal | undefined,
): {
  MFE_LOADED: string;
  INITIALIZE_ERROR: string;
  PERMISSIONS_UPDATE_ERROR: string;
  LEARN_MORE_IS_SHOWN: string;
  LEARN_MORE_IS_HIDDEN: string;
} => ({
  MFE_LOADED: getInlineEventName(INLINE_COOKIE_CUSTOM_EVENT_NAMES.MFE_LOADED, uniqueEventsPrefix),
  INITIALIZE_ERROR: getInlineEventName(
    INLINE_COOKIE_CUSTOM_EVENT_NAMES.INITIALIZE_ERROR,
    uniqueEventsPrefix,
  ),
  PERMISSIONS_UPDATE_ERROR: getInlineEventName(
    INLINE_COOKIE_CUSTOM_EVENT_NAMES.PERMISSIONS_UPDATE_ERROR,
    uniqueEventsPrefix,
  ),
  LEARN_MORE_IS_SHOWN: getInlineEventName(
    INLINE_COOKIE_CUSTOM_EVENT_NAMES.LEARN_MORE_IS_SHOWN,
    uniqueEventsPrefix,
  ),
  LEARN_MORE_IS_HIDDEN: getInlineEventName(
    INLINE_COOKIE_CUSTOM_EVENT_NAMES.LEARN_MORE_IS_HIDDEN,
    uniqueEventsPrefix,
  ),
});
